import { render, staticRenderFns } from "./CriteriaStructureManagement.vue?vue&type=template&id=fadc1abc"
import script from "./CriteriaStructureManagement.vue?vue&type=script&lang=js"
export * from "./CriteriaStructureManagement.vue?vue&type=script&lang=js"
import style0 from "./CriteriaStructureManagement.vue?vue&type=style&index=0&id=fadc1abc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports